<template>
  <div class="col s12 m6 l4">
    <div class="card sticky-action" style="width:100%;">
      <table>
        <div @submit.prevent="Get_quota_and_num_publ">
          <caption class="messageoutput" >ЭТАП 1. ЗАГРУЗКА ДАННЫХ О ПУБЛИКАЦИЯХ ИЗ СИСТЕМЫ SCOPUS В ПРОМЕЖУТОЧНУЮ БД</caption>
          <tr>
            <td colspan="3" class="form_description">
              Для получения информации о количестве новых (отсутствующих в промежуточной БД) публикаций в системе Scopus и квоте на их выгрузку укажите требуемый временной период в форме ниже, затем нажмите на кнопку 'Получить информацию'.
              <br>
            </td>
          </tr>
          <tr>
            <td>Год, за который требуется выгрузить публикации:
              <span class="input-field">
                <span v-if="checked === 'no'">
                  <input type="number" v-model="yearPubl2" id="Year_0" name="tentacles" min="1500" max="9999" style="width:60px; height:18px;" class="card-content red-text" :class="{ invalid: ( $v.yearPubl2.$dirty && !$v.yearPubl2.required && checked === 'no') || ( $v.yearPubl2.$dirty && !$v.yearPubl2.minLength && checked === 'no') }"> г.
                  <small
                    class="helper-text invalid"
                    v-if="$v.yearPubl2.$dirty && !$v.yearPubl2.required && checked === 'no'"
                  >Поле год является обязательным для заполнения (формат данных: число)!
                  </small>
                  <small
                    class="helper-text invalid"
                    v-else-if="$v.yearPubl2.$dirty && !$v.yearPubl2.minLength && checked === 'no'"
                  >Год должен состоять из {{ $v.yearPubl2.$params.minLength.min }} цифр. Сейчас количество цифр: {{yearPubl2.length}} шт.
                  </small>
                </span>
              </span>
              <span class="input-field">
                <span v-if="checked === 'yes'">
                  c <input type="number" v-model="yearPubl1" id="Year_1" name="tentacles" min="1500" max="9999" style="width:60px; height:18px;" class="card-content red-text" :class="{ invalid: ( $v.yearPubl1.$dirty && !$v.yearPubl1.required && checked === 'yes') || ( $v.yearPubl1.$dirty && !$v.yearPubl1.minLength && checked === 'yes') }">
                  по <input type="number" v-model="yearPubl2" id="Year_2" name="tentacles" min="1500" max="9999" style="width:60px; height:18px;" class="card-content red-text" :class="{ invalid: ( $v.yearPubl2.$dirty && !$v.yearPubl2.required && checked === 'yes') || ( $v.yearPubl2.$dirty && !$v.yearPubl2.minLength && checked === 'yes') }"> гг.
                  <div>
                  <small
                    class="helper-text invalid"
                    v-if="$v.yearPubl1.$dirty && !$v.yearPubl1.required  && checked === 'yes'"
                  >Поле для ввода начала периода ('с') является обязательным для заполнения (формат данных: число)!
                  </small>
                  <small
                    class="helper-text invalid"
                    v-else-if="$v.yearPubl1.$dirty && !$v.yearPubl1.minLength  && checked === 'yes'"
                  >Год (поле 'с') должен состоять из {{ $v.yearPubl1.$params.minLength.min }} цифр. Сейчас количество цифр: {{yearPubl1.length}} шт.
                  </small>
                  </div>
                  <div>
                  <small
                    class="helper-text invalid"
                    v-if="$v.yearPubl2.$dirty && !$v.yearPubl2.required && checked === 'yes'"
                  >Поле для ввода окончания периода ('по') является обязательным для заполнения (формат данных: число)!!
                  </small>
                  <small
                    class="helper-text invalid"
                    v-else-if="$v.yearPubl2.$dirty && !$v.yearPubl2.minLength && checked === 'yes'"
                  >Год (поле 'по') должен состоять из {{ $v.yearPubl2.$params.minLength.min }} цифр. Сейчас количество цифр: {{yearPubl2.length}} шт.
                  </small>
                  </div>
                </span>
              </span>
              <span>
                <label><input v-model="checked" true-value="yes" false-value="no" id="checkbox" type="checkbox"/><span>Ввести временной диапазон</span></label>
              </span>
            </td>
            <td>
              <button :disabled="isButtonDisabled" class="btn-small btn-primary" @click="Get_quota_and_num_publ">Получить информацию<i class="material-icons right">send</i></button>
              <br>
            </td>
          </tr>
        </div>
        <tr>
          <div v-if="loading === false">
            <span class="messageoutput">Операция выполняется, пожалуйста, подождите!</span>
            <div class="progress"><div class="indeterminate"></div></div>
          </div>
        </tr>
        <!--если лимит Не превышен, то:-->
        <div v-if="getQuotaAndNumPublStatus === 3">
          <tr>
            <td>Количество новых публикаций за указанный период
              <span v-if="checked === 'no'">
              ({{yearName}} г.),
              </span>
              <span v-if="checked === 'yes'">
              ({{yearName}} гг.),<!--({{yearPubl1 + '-' + yearPubl2}}) выше изменено, что при нажатии на кнопку менялось-->
            </span> подлежащих выгрузке: <span class="colortext"> {{ getQuotaAndPubl.len_list_publ_id }} </span> шт.</td>
          </tr>
          <tr>
            <td>Оставшийся лимит на выгрузку публикаций на 7 дней составляет: <span class="colortext"> {{ getQuotaAndPubl.X_RateLimit_Remaining }} </span> шт. (из {{ getQuotaAndPubl.X_RateLimit_Limit }} возможных)  </td>
          </tr>
          <td>
             <span>
               <button :disabled="isButtonDisabled_2" class="btn btn-primary" @click="UploadPublicationsIntermediate">Загрузить публикации в промежуточную БД<i class="material-icons right">send</i></button>
               <span v-if="uploadPublicationsIntermediate === -1 && lenListPublId!==0">
                 (загрузка публикаций ориентировочно займет:
                 <span v-if="hours !== 0">
                   {{this.hours}} ч.
                 </span>
                  <span v-if="minutes !== 0">
                   {{this.minutes}} мин.
                 </span>
                 <span v-if="seconds !== 0">
                   {{this.seconds }} сек.)
                 </span>
               </span>
               <span v-if="isButtonDisabled_2 === false">
                <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
               </span>
               <span v-if="lenListPublId===0">
                <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
               </span>
             </span>
          </td>
          <tr>
            <div v-if="loading_2 === false">
              <!--        <tr v-if="counter === 1">-->
              <!--          <Loader v-if="loading === true" />-->
              <!--          <div v-else class="row">-->
              <span class="messageoutput">Операция выполняется. По окончании выполнения операции на экране появится соответствующее сообщение.</span>
              <div class="progress" ><div class="indeterminate"></div></div>
            </div>
          </tr>
          <!--Дата некорректна-->
          <div v-if="uploadPublicationsIntermediate === 11">
            <tr>
              <td class="messageoutput">
                Новых публикаций за указанный промежуток времени в системе Scopus не обнаружено.
              </td>
            </tr>
          </div>
          <div v-else-if="uploadPublicationsIntermediate === 3">
            <tr>
              <td class="messageoutput">
                Загрузка новых публикаций в промежуточную БД за указанный промежуток времени ({{yearName}} г.) осуществлена успешно!
                <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
              </td>
            </tr>
          </div>
          <div v-else-if="uploadPublicationsIntermediate === 2">
            <tr>
              <td class="helper-text invalid">
                Лимит на выгрузку публикаций по API Scopus закончился. Через 7 дней (с момента исчерпания лимита) Вы сможете продолжить работу в системе.
              </td>
            </tr>
          </div>
          <div v-else-if="uploadPublicationsIntermediate === 4">
            <tr>
              <td class="helper-text invalid">
                В процессе операции (на стороне backend) произошла ошибка. Пожалуйста, обратитесь к администратору системы.
              </td>
            </tr>
          </div>
          <div v-else-if="uploadPublicationsIntermediate === 5">
            <tr>
              <td class="helper-text invalid">
                Ошибка доступа! API ключ для доступа к серверной части приложения (Backend) некорректный. Пожалуйста, обратитесь к администратору системы.
              </td>
            </tr>
          </div>
          <div v-else-if="uploadPublicationsIntermediate === 6">
            <tr>
              <td class="helper-text invalid">
                Не удается подключиться к серверу. Пожалуйста, попробуйте еще раз, сейчас или позже.
              </td>
            </tr>
          </div>
          <div v-else-if="uploadPublicationsIntermediate === 1">
            <tr>
              <td class="helper-text invalid">
              <span v-if="checked === 'no'">
              Введенный Вами формат даты ({{yearName}}) некорректен!
              </span>
                <span v-if="checked === 'yes'">
              Введенный Вами диапазон и (или) формат дат(ы) ({{yearName}}) некорректен! Дата начала периода не должна совпадать или быть больше даты окончания периода.
              </span>
              </td>
            </tr>
          </div>
        </div>
        <!--Дата некорректна-->
        <div v-else-if="getQuotaAndNumPublStatus === 1">
          <tr>
            <td class="helper-text invalid">
              <span v-if="checked === 'no'">
              Введенный Вами формат даты ({{yearName}}) некорректен!
              </span>
              <span v-if="checked === 'yes'">
              Введенный Вами диапазон и (или) формат дат(ы) ({{yearName}}) некорректен! Дата начала периода не должна совпадать или быть больше даты окончания периода.
              </span>
              <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
            </td>
          </tr>
        </div>
        <!--API ключ для доступа к серверной части приложения (Backend) некорректный.-->
        <div v-else-if="getQuotaAndNumPublStatus === 5">
          <tr>
            <td class="helper-text invalid">
              Ошибка доступа! API ключ для доступа к серверной части приложения (Backend) некорректный. Пожалуйста, обратитесь к администратору системы.
              <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
            </td>
          </tr>
        </div>
        <div v-else-if="getQuotaAndNumPublStatus === 22">
          <tr>
            <td class="helper-text invalid">
              Превышено допустимое количество результатов поиска. Уменьшите временной интервал.
              <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
            </td>
          </tr>
        </div>
        <div v-else-if="getQuotaAndNumPublStatus === 101">
          <tr>
            <td class="helper-text invalid">
              Публикаций не найдено за указанный промежуток времени.
              <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
            </td>
          </tr>
        </div>
        <!--Лимит на выгрузку публикаций по API Scopus закончился-->
        <div v-else-if="getQuotaAndNumPublStatus === 2">
          <tr>
            <td class="helper-text invalid">
              Лимит на выгрузку публикаций по API Scopus закончился. На каждые 7 выделяется квота в размере 10 000 запросов. Через 7 дней (с момента исчерпания лимита) Вы сможете продолжить работу в системе.
              <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
            </td>
          </tr>
        </div>
        <!--В процессе операции (на стороне backend) произошла ошибка. Пожалуйста, обратитесь к администратору системы.-->
        <div v-else-if="getQuotaAndNumPublStatus === 4">
          <tr>
            <td class="helper-text invalid">
              В процессе операции (на стороне backend) произошла ошибка. Пожалуйста, обратитесь к администратору системы.
              <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
            </td>
          </tr>
        </div>
        <!--Не удается подключиться к серверу.-->
        <div v-else-if="getQuotaAndNumPublStatus === 6">
          <tr>
            <td class="helper-text invalid">
              Не удается подключиться к серверу. Пожалуйста, попробуйте еще раз, сейчас или позже.
              <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
            </td>
          </tr>
        </div>
      </table>
    </div>
  </div>
</template>

<style>
  .colortext {
    color: #013f28;
    font-weight:bold;
  }
  .messageoutput {
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    color: #013f28;
    font-weight:bold;
  }
  .form_description{
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    font-size: 120%; /* Размер шрифта в процентах */
    font-weight: normal; /* Нормальное начертание */
    color: #013f28;
    font-style: italic; /* Курсивное начертание */
  }
  /*table, th, td {*/
  /*  border: 1px solid black;*/
  /*}*/
</style>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import { KEY } from '../../keys.js'
import { URLB } from '../../url'
export default {
  data () {
    return {
      isButtonDisabled: false, /* блокировка нажатия кнопки 'Получить информацию' ИЗНАЧАЛЬНО: активная */
      isButtonDisabled_2: true, /* блокировка нажатия кнопки 'загрузка публикаций в промежуточную БД' ИЗНАЧАЛЬНО: заблокирована */
      yearPubl1: (new Date().getFullYear() - 1), /* года для ввода'  {{ date | date('year') }} */
      yearPubl2: new Date().getFullYear(), /* года для ввода' */
      yearName: '', /* формирование года для api (конкретный год или диапазон)' */
      checked: 'no', /* переключатель год или диапазон в гг - отслеживание выбора пользователя ("yes"/"no")  */
      getQuotaAndPubl: '', /* обнуление результата API при нажатии на кнопку 'Получить информацию' */
      scopusDownloadPyblApi: '', /* когд ответа json при загрузке пебликаций */
      loading: true, /* на время выполнения api запроса скрывать поля с результатом */
      loading_2: true, /* на время выполнения api запроса скрывать поля с результатом */
      getQuotaAndNumPublStatus: 0,
      uploadPublicationsIntermediate: -1,
      XELSCODE: 0,
      lenListPublId: 0,
      XRateLimit_Remaining: 0,
      hours: 0, /* время выполнения операции */
      minutes: 0, /* время выполнения операции */
      seconds: 0 /* время выполнения операции */
    }
  },
  validations: {
    yearPubl1: {
      required,
      minLength: minLength(4)
    },
    yearPubl2: {
      required,
      minLength: minLength(4)
    }
  },
  methods: {
    Get_quota_and_num_publ () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      this.hours = 0
      this.minutes = 0
      this.seconds = 0
      this.isButtonDisabled_2 = true /* неактивная кнопка выгрузки публикаций в промежуточную базу по API */
      this.loading = false
      this.isButtonDisabled = true
      // this.isButtonDisabled_2 = true
      this.getQuotaAndPubl = ''
      this.getQuotaAndNumPublStatus = 0
      this.uploadPublicationsIntermediate = -1
      var yearName
      // var yearname = this.year_publ[1]
      if (this.checked === 'no') {
        yearName = this.yearPubl2
      }
      if (this.checked === 'yes') {
        yearName = this.yearPubl1 + '-' + this.yearPubl2
      }
      this.yearName = yearName
      // var yearname = this.year_publ[1]
      const apiKeyBack = KEY.APIKEY_BACKEND
      const urlBack = URLB.URL_BACKEND
      this.$http.get(`${urlBack}/api/content/quota_api_and_quantity_publ_scopus/date/${yearName}?apiKey=${apiKeyBack}`)
        .then(response => {
          return response.json()
        })
        .catch(error => {
          console.log(error)
          this.getQuotaAndNumPublStatus = 6
        })
        .then(getQuotaAndPubl => {
          this.getQuotaAndPubl = getQuotaAndPubl
          this.loading = true
          this.isButtonDisabled = false
          this.statusGetQuotaAndPubl = getQuotaAndPubl.X_ELS_CODE
          // console.log(this.getQuotaAndNumPublStatus)
          if (this.statusGetQuotaAndPubl === 1) {
            this.getQuotaAndNumPublStatus = 1
            return
          }
          if (this.statusGetQuotaAndPubl === 3) {
            this.getQuotaAndNumPublStatus = 3
            this.lenListPublId = Number(getQuotaAndPubl.len_list_publ_id)
            this.XRateLimit_Remaining = Number(getQuotaAndPubl.X_RateLimit_Remaining)
            if (this.lenListPublId > 0) {
              this.isButtonDisabled_2 = false
              this.hours = Math.floor((this.lenListPublId * 2.3) / 60 / 60)
              this.minutes = Math.floor((this.lenListPublId * 2.3) / 60) - (this.hours * 60)
              this.seconds = Math.floor((this.lenListPublId * 2.3) % 60)
              // this.resultLoadingApiPubl = this.hours + ':' + this.minutes + ':' + this.seconds && this.lenListPublId < this.XRateLimit_Remaining
            }
            return
          }
          if (this.statusGetQuotaAndPubl === 5) {
            this.getQuotaAndNumPublStatus = 5
            return
          }
          if (this.statusGetQuotaAndPubl === 2) {
            this.getQuotaAndNumPublStatus = 2
            return
          }
          if (this.statusGetQuotaAndPubl === 4) {
            this.getQuotaAndNumPublStatus = 4
            return
          }
          if (this.statusGetQuotaAndPubl === 101) {
            this.getQuotaAndNumPublStatus = 101
            return
          }
          if (this.statusGetQuotaAndPubl === 8) {
            this.getQuotaAndNumPublStatus = 8
            return
          }
          if (this.statusGetQuotaAndPubl === 22) {
            this.getQuotaAndNumPublStatus = 22
          }
        })
    },
    UploadPublicationsIntermediate () {
      this.uploadPublicationsIntermediate = -1
      this.isButtonDisabled_2 = true
      this.loading_2 = false
      const apiKeyBack = KEY.APIKEY_BACKEND
      const urlBack = URLB.URL_BACKEND
      this.$http.get(`${urlBack}/api/content/scopus_download_pybl_api/date/${this.yearName}/doc_type/all?apiKey=${apiKeyBack}`)
        .then(response => {
          return response.json()
        })
        .catch(error => {
          console.log(error)
        })
        .then(scopusDownloadPyblApi => {
          this.loading_2 = true
          this.isButtonDisabled_2 = false
          this.isButtonDisabled = false
          this.scopusDownloadPyblApi = scopusDownloadPyblApi
          this.statusDownloadPyblApi = Number(scopusDownloadPyblApi.X_ELS_CODE)
          if (this.statusDownloadPyblApi === 11) {
            this.uploadPublicationsIntermediate = 11
            return
          }
          if (this.statusDownloadPyblApi === 3) {
            this.uploadPublicationsIntermediate = 3
            this.isButtonDisabled_2 = true
            return
          }
          if (this.statusDownloadPyblApi === 4) {
            this.uploadPublicationsIntermediate = 4
            return
          }
          if (this.statusDownloadPyblApi === 5) {
            this.uploadPublicationsIntermediate = 5
          }
        })
    },
    cleaningForm () {
      this.isButtonDisabled = false /* блокировка нажатия кнопки 'Получить информацию' ИЗНАЧАЛЬНО: активная */
      this.isButtonDisabled_2 = true /* блокировка нажатия кнопки 'Получить информацию' ИЗНАЧАЛЬНО: заблокирована */
      this.yearPubl1 = (new Date().getFullYear() - 1) /* года для ввода'  {{ date | date('year') }} */
      this.yearPubl2 = new Date().getFullYear() /* года для ввода' */
      this.yearName = '' /* формирование года для api (конкретный год или диапазон)' */
      this.checked = 'no' /* переключатель год или диапазон в гг - отслеживание выбора пользователя ("yes"/"no")  */
      this.getQuotaAndPubl = '' /* обнуление результата API при нажатии на кнопку 'Получить информацию' */
      this.scopusDownloadPyblApi = ''
      this.loading = true /* на время выполнения api запроса скрывать поля с результатом */
      this.loading_2 = true /* на время выполнения api запроса скрывать поля с результатом */
      this.getQuotaAndNumPublStatus = 0
      this.uploadPublicationsIntermediate = -1
      this.XELSCODE = 0
      this.lenListPublId = 0
      this.XRateLimit_Remaining = 0
      this.hours = 0 /* время выполнения операции */
      this.minutes = 0 /* время выполнения операции */
      this.seconds = 0 /* время выполнения операции */
    }
  }
}
</script>
